import { render, staticRenderFns } from "./TkTable.vue?vue&type=template&id=0a23591d&"
import script from "./TkTable.vue?vue&type=script&lang=js&"
export * from "./TkTable.vue?vue&type=script&lang=js&"
import style0 from "./TkTable.vue?vue&type=style&index=0&id=0a23591d&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports